/* eslint-disable jsx-a11y/no-autofocus */
import React from 'react';
import styled from 'styled-components';
import { Button, Flex, GenericBanner, Text, getPaletteColor } from 'pcln-design-system';
import ChildrenLineItem from '../ChildrenLineItem';
import TravelerLineItem from '../TravelerLineItem';
import Divider from '../Divider';
import { DEFAULT_MAX_ROOMS, ROOM_SIZE } from '../constants';
import { ArrowRight as ArrowRightIcon, Bed as BedIcon } from 'pcln-icons';
const MaxRoomsMessageText = /*#__PURE__*/styled(Text).withConfig({
  displayName: "TravelerSelectionContent__MaxRoomsMessageText",
  componentId: "sc-1mr9jxf-0"
})(["&&&:hover{color:", ";text-decoration:underline;}"], getPaletteColor('primary.dark'));
const PopoverContent = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "TravelerSelectionContent__PopoverContent",
  componentId: "sc-1mr9jxf-1"
})(["flex-direction:column;height:100%;overflow-y:scroll;pointer-events:auto;font-family:", ";"], props => props.theme.font);
function TravelerSelectionContent({
  ageSelectEnabled,
  autoFocus,
  className,
  disclaimer,
  isHotel,
  isPopover,
  maxAdults,
  maxChildren,
  fireMaxRoomsOnClick,
  maxRooms: defaultMaxRooms = DEFAULT_MAX_ROOMS,
  maxRoomsMessage,
  maxRoomsUrl,
  roomsEnabled,
  state,
  handleClose,
  subLabelMap,
  lapInfantLabel,
  shouldCountLapInfant
}) {
  const maxRooms = ageSelectEnabled && roomsEnabled && maxAdults && maxChildren ? Math.ceil((maxAdults + maxChildren) / ROOM_SIZE) : defaultMaxRooms;
  const defaultMaxRoomsMessage = `You may only book up to ${maxRooms} rooms.`;
  const hasCustomMaxRoomsMessage = maxRoomsMessage && maxRoomsUrl;
  const hasFireMaxRoomsOnClick = Boolean(fireMaxRoomsOnClick);
  const finalMaxLapInfant = shouldCountLapInfant ? Math.min(state.adults, state.lapInfants + state.remainingTravelerCount) : state.adults;
  const finalMaxChildren = maxChildren ? Math.min(maxChildren, state.children + state.remainingTravelerCount) : state.children + state.remainingTravelerCount;
  function onMaxRoomsBannerClick() {
    if (fireMaxRoomsOnClick) {
      fireMaxRoomsOnClick();
    }
  }
  return React.createElement(PopoverContent, {
    className: className,
    px: 3
  }, roomsEnabled && React.createElement(React.Fragment, null, React.createElement(TravelerLineItem, {
    autoFocus: autoFocus,
    label: 'Rooms',
    min: 1,
    max: maxRooms,
    count: state.rooms,
    onChange: state.setRooms
  }), state.rooms === maxRooms && React.createElement(GenericBanner, {
    borderRadius: 'lg',
    color: 'caution.light',
    ctaText: (hasCustomMaxRoomsMessage || hasFireMaxRoomsOnClick) && React.createElement(MaxRoomsMessageText, {
      color: 'primary.base'
    }, ' ', React.createElement(Flex, {
      alignItems: 'center',
      mt: 2
    }, maxRooms + 1, " Rooms or More ", React.createElement(ArrowRightIcon, {
      size: 18,
      ml: 1
    }))),
    fontSize: 0,
    iconLeft: React.createElement(BedIcon, null),
    justifyContent: 'flex-start',
    px: 2,
    py: 2,
    mb: 3,
    text: React.createElement(Text, null, maxRoomsMessage || defaultMaxRoomsMessage),
    buttonClick: maxRoomsMessage && hasFireMaxRoomsOnClick && onMaxRoomsBannerClick,
    URLProps: !hasFireMaxRoomsOnClick && hasCustomMaxRoomsMessage && {
      href: maxRoomsUrl,
      target: '_blank'
    }
  }), React.createElement(Divider, null)), React.createElement(TravelerLineItem, {
    autoFocus: autoFocus && !roomsEnabled,
    label: 'Adults',
    subLabel: subLabelMap?.adults || '',
    min: 1,
    max: maxAdults || state.adults + state.remainingTravelerCount,
    count: state.adults,
    onChange: state.setAdults
  }), React.createElement(Divider, null), React.createElement(ChildrenLineItem, {
    ageSelectEnabled: ageSelectEnabled,
    max: finalMaxChildren,
    count: state.children,
    ages: state.childrenAges,
    isHotel: isHotel,
    onChange: state.setChildren,
    onAgeChange: state.setChildrenAges,
    subLabel: subLabelMap?.children || 'Ages 2 to 11'
  }), !ageSelectEnabled && React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(TravelerLineItem, {
    label: lapInfantLabel || 'Infants on Lap',
    subLabel: subLabelMap?.lapInfants || 'Under 2',
    min: 0,
    max: finalMaxLapInfant,
    count: state.lapInfants,
    onChange: state.setLapInfants
  })), disclaimer && React.createElement(Text, {
    color: 'text.light',
    fontSize: 0,
    mb: 3,
    mt: 2
  }, disclaimer), !disclaimer && roomsEnabled && ageSelectEnabled && React.createElement(Text, {
    color: 'text.light',
    fontSize: 0,
    mb: 3,
    mt: 2
  }, "Add your child's age at check-in for the best deals and assistance. Each hotel has unique policies."), isPopover && React.createElement(Flex, {
    justifyContent: 'flex-end'
  }, React.createElement(Button, {
    size: 'medium',
    onClick: handleClose,
    mb: 3
  }, "Done")));
}
export default TravelerSelectionContent;